// extracted by mini-css-extract-plugin
export default {"control-title":"Controls_control-title__9GOaR","info-icon":"Controls_info-icon__PiLSN","word-sets-info":"Controls_word-sets-info__an+Xj"};